import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HeaderService {
  searchPlaceholder?: string;

  searchAction?: (searchString: string) => void;

  registerAction(fn: (searchString: string) => void, label: string) {
    this.searchAction = fn;
    this.searchPlaceholder = label;
    
  }

  removeAction() {
    delete this.searchAction;

    delete this.searchPlaceholder;
  }
}
